import react, {useState, useEffect} from 'react';
import { useFormik } from 'formik';
// import CreateBookForm from './CreateBookForm';
import { toast } from "react-toastify";

import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { convertFromHTML } from "draft-convert";
import draftToHtml from "draftjs-to-html";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { loadAsyncOptions } from "../bookUtils";
import FormikInput from '../../../components/Inputs/formik/FormikInput';

// components
import {
  Row, 
  Col, 
  Modal, 
  Button,
  Form,
  ToggleButton
} from 'react-bootstrap';

import { getBookById, updateBook, createBook } from "../../../api/books";

import { format } from 'date-fns'

export default function CreateBookDialog(props) {

    const { show, handleClose, lang, current, onFinish } = props;

    const defaultValues ={
        active:true,
        _id:"",
        id:"",
        title:"",
        subtitle:"",
        price:0,
        price1:0,
        price2:0,
        price3:0,
        faculty:"",
        editorial:"",
        isbn13:"",
        creationDate:format(new Date(), 'yyyy-MM-dd'),
        authors:[],
        summary:"",
        topic:"",
        keywords:[],
        audience:"",
        primaryContentType:"",
        collectionTag:"general",
        fileFormat:"Impreso",
        formatDetails:"",
        openURL:"",
        doi:"",
        sieelSKU:"",
        bwSKU:"",
        bisac:"",
        customized:"",        
        hasIlustrations:true,
        physicalDimentions:"",
        editionNumber:1,
        language:"es",
        pages:"",
        publicationCity:"",
        publicationCountry:"",
        editionYear:format(new Date(), 'yyyy'),
        sellingRights:"Ninguno",
        sellingConstraints:"Ninguno",
        market:"general",
        sellingConstraints:"",
        market:"",
        collaborators:[],
        favorites:[],
        coverImage:"/assets/app/cover.jpg",
        image_file: null,
        image_preview: '',
    }
    const [formData, setFormData] = useState(defaultValues)
    const [preview, setPreview] = useState(defaultValues.coverImage);
    const [file, setFile] = useState(null);
    const [isValid, setValidate] = useState(true);

    const formik = useFormik({
        initialValues: defaultValues,
        onSubmit: values => { return; }
    })
    
    const previewImage = (e) => {
        setPreview(URL.createObjectURL(e.target.files[0]));
        setFile(e.target.files[0]);
    }

    const handleOnchange = (event) => {
        const {
            name,
            value
        } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
        formik.setFieldValue(name, value);
    };
    const [isMounted, setIsMounted] = useState(false)

    const [editDesctiption, setDescriptionState] = useState(() =>{
        if(!isMounted) return;
        return !formData.description?
            EditorState.createEmpty() :
                EditorState.createWithContent(convertFromHTML(current.summary));
    });
    
    const editorChange = (state) => {
        setDescriptionState(state);
        let data = {
            "summary": draftToHtml(convertToRaw(editDesctiption.getCurrentContent()))
        }
        console.log("editorChange ", data)
        setFormData({
            ...formData,
            ...data})
    };

    useEffect(() => {
        if(!current){
            setFormData({...defaultValues});
            setPreview(defaultValues.coverImage);
            formik.setFieldValue("collaborators",[]);

            setDescriptionState(EditorState.createWithContent(convertFromHTML(`<span></span>`))) ;
        }
    },[show])

    useEffect(() => {
        if(!current) return;
        try {
            setDescriptionState(EditorState.createWithContent(convertFromHTML(current.summary))) 
        } catch (error) {
            setDescriptionState(EditorState.createWithContent(convertFromHTML(`<span>${current.summary}</span>`)))
        }
    },[current])

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!isValid) return;
        if (file !== null) formData['image_file'] = file;
        const data = {
            ...formData,
            ...{
                "authors[]":formik?.values?.collaborators.map(item=>item.value),
                "collaborators[]":formik?.values?.collaborators.map(item=>item.label),
                "keywords[]": formik?.values?.keywords.map(item=>item.label),
                // "summary":convertToRaw(formData.summary.getCurrentContent())
            }
        }
        if(current){
            updateBook(data._id, data).then(res=>{
                onFinish(res); 
                toast.success(`¡La obra ha sido actualizada en el catálogo!`,{
                    position: toast.POSITION.TOP_RIGHT,
                    className: "foo-bar",
                    autoClose: 4000,
                    pauseOnHover: false,
                });
                handleClose();
                return;
            }).catch(err=>{
                toast.warning("Ha fallado la actualización del catálogo!",{
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                    pauseOnHover: false,
                });
            });
            return;
        }
        createBook(data).then(res=>{
            onFinish(res);
            toast.success(`¡La obra esta en el catálogo!`,{
                position: toast.POSITION.TOP_RIGHT,
                className: "foo-bar",
            });
            handleClose();
        }).catch(err=>{
            toast.warning("La obra NO esta en el catálogo, hubo un error!",{
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 4000,
                pauseOnHover: false,
            });
        });
        return;
    }

    const reload = (current)=>{
        if(!current) return;
        getBookById(current._id)
            .then((response)=>{
                const { data } = response;
                
                setFormData({
                    ...formData,
                    // ...current,
                    ...data, 
                    ...{
                        'id':data._id, 
                        creationDate: format(new Date(data.creationDate), 'yyyy-MM-dd'),
                    }
                })
                formik.setFieldValue("collaborators",data.collaborators.map((val,idx)=>{
                    return { "value": data.authors[idx]._id, "label":val }
                }));
                // formik.setFieldValue("summary", EditorState.createWithContent(
                //         convertFromRaw(JSON.parse(data.summary))
                //     )
                // );
                formik.setFieldValue("authors", data.authors);
                formik.setFieldValue("keywords", data.keywords);
                // formik.setFieldValue("keywords",data.keywords.map((val)=>{
                //     return { "value": val, "label":val }
                // }));
                setPreview(current.coverImage)
            })
            .catch((error)=>{

            })
    }

    const removeImage = () =>{
        setFile(null)
        setPreview("/assets/app/cover.jpg")
        setFormData({
            ...formData,
            ...{'image_file':null,"coverImage":"/assets/app/cover.jpg"}
        });
        const data = {
            ...formData,
            ...{
                "authors[]":formik?.values?.collaborators.map(item=>item.value),
                "collaborators[]":formik?.values?.collaborators.map(item=>item.label),
                "keywords[]": formik?.values?.keywords.map(item=>item.label),
                // "summary":convertToRaw(formData.summary.getCurrentContent())
            }
        }
        updateBook(data._id, data).then(res=>{
            onFinish(res); 
            toast.success(`¡La obra ha sido actualizada en el catálogo!`,{
                position: toast.POSITION.TOP_RIGHT,
                className: "foo-bar",
                autoClose: 4000,
                pauseOnHover: false,
            });
            handleClose();
            return;
        }).catch(err=>{
            toast.warning("Ha fallado la actualización del catálogo!",{
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 4000,
                pauseOnHover: false,
            });
        });
        return;
    }
    
    useEffect(() => {
        if(current){
            reload(current)
        }else{
            setFormData({...defaultValues});
            setPreview(defaultValues.coverImage);
            formik.setFieldValue("collaborators",[]);
        }
    },[current])

    return (
        <Modal show={show} onHide={handleClose}>
            <Form onSubmit={handleSubmit}>
                <Modal.Header style={{
                display:'flex',
                justifyContent:'space-between'
                }}>
                    <Modal.Title>Panel de obras</Modal.Title>
                    <div className="" role="group">
                    <Button size="sm" variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button> {' '}
                    <Button size="sm" variant="primary" type="submit">
                        Guardar cambios
                    </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <input type="hidden" name="id" id="id" value={formData._id}/>
                    <Row>
                        <Col 
                            xs={{ span: 10, order: 2 }} sm={{ span: 10, order: 2 }} md={2}
                            style={{
                                "display": 'flex',
                                "flexDirection": 'column',
                                "alignItems": 'center'
                            }}
                        >
                            <img
                                className="img-fluid img-thumbnail mb-3"
                                src={preview}
                                alt="author-pic"
                                style={{ maxHeight:"300px", minHeight:"200px" }}
                            />
                            <Form.Control
                                className='mb-3'
                                onChange={previewImage}
                                type="file"
                                accept="image/*"
                                placeholder="Imagen"
                            />
                            <span 
                                className='btn btn-secondary btn-block btn-sm' 
                                style={{ width:'100%' }}
                                onClick={removeImage}
                            >
                                Eliminar imagen
                            </span>
                            <ToggleButton
                                className="form-control"
                                id={'active'}
                                name={'active'}
                                type="checkbox"
                                variant="outline-primary"
                                checked={formData.active}
                                value={formData.active}
                                onChange={(e)=>handleOnchange({target:{
                                    name:'active',
                                    value:!formData.active
                                }})}
                            >
                                {formData.active ? "Activo":"Inactivo"}
                            </ToggleButton>
                        </Col>
                        <Col md={10}>
                            <Row>
                                <Form.Group controlId="title">
                                <Form.Label>Titulo (*)</Form.Label>
                                <Form.Control
                                    name={'title'}
                                    defaultValue={formData.title}
                                    onChange={handleOnchange}
                                    placeholder=""
                                    required
                                ></Form.Control>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Col sm={12} md={4}>
                                <Form.Group controlId="price">
                                    <Form.Label>Precio (*) </Form.Label>
                                    <Form.Control
                                        name={'price'}
                                        value={formData.price}
                                        onChange={handleOnchange}
                                        placeholder=""
                                        required
                                    ></Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={8}>
                                <Form.Group controlId="subtitle">
                                    <Form.Label>Subtitulo </Form.Label>
                                    <Form.Control
                                        name={'subtitle'}
                                        defaultValue={formData.subtitle}
                                        onChange={handleOnchange}
                                        placeholder=""
                                    ></Form.Control>
                                </Form.Group>
                                </Col>
                            </Row>
                        
                            <Row>
                                <Col sm={12} md={4}>
                                    <Form.Group controlId="editorial">
                                    <Form.Label>Editorial (*)</Form.Label>
                                    <Form.Control
                                        name={'editorial'}
                                        defaultValue={formData.editorial}
                                        onChange={handleOnchange}
                                        placeholder=""
                                        required
                                    ></Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={4}>
                                    <Form.Group controlId="isbn13">
                                    <Form.Label>ISBN13 (*)</Form.Label>
                                    <Form.Control
                                        name={'isbn13'}
                                        defaultValue={formData.isbn13}
                                        onChange={handleOnchange}
                                        placeholder=""
                                        required
                                    ></Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={4}>
                                    <Form.Group controlId="creationDate">
                                    <Form.Label>Creación (*) </Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        name={'creationDate'}
                                        defaultValue={formData.creationDate}
                                        onChange={handleOnchange}
                                        type="date"
                                        required
                                    ></Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>

                        <Row>
                            <Form.Group controlId="authors">
                                <FormikInput
                                    formik={formik}
                                    fieldName={"Autor / autores"}
                                    jsonField={{
                                        id: "collaborators",
                                        required: true,
                                        placeholder: lang.book.placeholder.collaborators,
                                        type: "select-look",
                                        validations:[{
                                            type: "array",
                                            params: [""]
                                        },{
                                            type: "min",
                                            params: [1, lang.book.validation.min_author]
                                        }],
                                        zeroValue: []
                                    }}
                                    loadAsyncOptions={loadAsyncOptions}
                                    lang={props.lang}
                                />
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group controlId="summary">
                                <Form.Label>Descripción/Resumen</Form.Label>
                                {show && <Editor
                                    editorState={editDesctiption}
                                    onEditorStateChange={editorChange}
                                    wrapperClassName="author-editor-wrapper"
                                    editorClassName="author-editor"
                                /> }
                            </Form.Group>
                        </Row>

                        </Col>
                    </Row>



                    <Row>
                        <Col sm={12} md={3}>
                            <Form.Group controlId="topic">
                            <Form.Label>Tema</Form.Label>
                            <Form.Control
                                name={'topic'}
                                value={formData.topic}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={9}>
                            <Form.Group controlId="keywords">
                            <FormikInput
                                formik={formik}
                                fieldName={"Palabras clave"}
                                jsonField={ {
                                    id: "keywords",
                                    required: false,
                                    placeholder: lang.book.placeholder.keywords,
                                    type: "select-create",
                                    validations:
                                        [{
                                            type: "array",
                                            params: [""]
                                        }
                                        ],
                                    zeroValue: []
                                }}
                                loadAsyncOptions={loadAsyncOptions}
                                lang={props.lang}
                            />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} md={3}>
                            <Form.Group controlId="audience">
                            <Form.Label>Audiencia</Form.Label>
                            <Form.Control
                                name={'audience'}
                                defaultValue={formData.audience}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={5}>
                            <Form.Group controlId="primaryContentType">
                            <Form.Label>Tipo de contenido</Form.Label>
                            <Form.Control
                                name={'primaryContentType'}
                                defaultValue={formData.primaryContentType}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={4}>
                            <Form.Group controlId="collectionTag">
                            <Form.Label>Colección</Form.Label>
                            <Form.Control
                                name={'collectionTag'}
                                defaultValue={formData.collectionTag}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} md={3}>
                            <Form.Group controlId="fileFormat">
                            <Form.Label>Formato</Form.Label>
                            <Form.Control
                                name={'fileFormat'}
                                defaultValue={formData.fileFormat}
                                onChange={handleOnchange}
                                placeholder="Impreso/Digital"
                                required
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={5}>
                            <Form.Group controlId="formatDetails">
                            <Form.Label>Detalle</Form.Label>
                            <Form.Control
                                name={'formatDetails'}
                                defaultValue={formData.formatDetails}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={4}>
                            <Form.Group controlId="openURL">
                            <Form.Label>URL</Form.Label>
                            <Form.Control
                                name={'openURL'}
                                defaultValue={formData.openURL}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} md={4}>
                            <Form.Group controlId="doi">
                            <Form.Label>DOI</Form.Label>
                            <Form.Control
                                name={'doi'}
                                defaultValue={formData.doi}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={4}>
                            <Form.Group controlId="sieelSKU">
                            <Form.Label>SIIEL SKU</Form.Label>
                            <Form.Control
                                name={'sieelSKU'}
                                defaultValue={formData.sieelSKU}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={4}>
                            <Form.Group controlId="bwSKU">
                            <Form.Label>BW SKU</Form.Label>
                            <Form.Control
                                name={'bwSKU'}
                                defaultValue={formData.bwSKU}
                                onChange={handleOnchange}
                                placeholder=""
                                required
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>


                    <Row>
                        <Col sm={12} md={4}>
                            <Form.Group controlId="physicalDimentions">
                            <Form.Label>Dimensiones físicas</Form.Label>
                            <Form.Control
                                name={'physicalDimentions'}
                                defaultValue={formData.physicalDimentions}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={4}>
                            <Form.Group controlId="weight">
                            <Form.Label>Peso (Físico)</Form.Label>
                            <Form.Control
                                name={'weight'}
                                defaultValue={formData.weight}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={4}>
                            <Form.Group controlId="pages">
                            <Form.Label>Núm. Páginas (*)</Form.Label>
                            <Form.Control
                                name={'pages'}
                                defaultValue={0 || formData.pages}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} md={3}>
                            <Form.Group controlId="publicationCountry">
                            <Form.Label>País de publicación</Form.Label>
                            <Form.Control
                                name={'publicationCountry'}
                                defaultValue={formData.publicationCountry}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={3}>
                            <Form.Group controlId="publicationCity">
                            <Form.Label>Ciudad de publicación</Form.Label>
                            <Form.Control
                                name={'publicationCity'}
                                defaultValue={formData.publicationCity}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={3}>
                            <Form.Group controlId="language">
                            <Form.Label>Idioma</Form.Label>
                            <Form.Control
                                name={'language'}
                                defaultValue={formData.language}
                                onChange={handleOnchange}
                                placeholder="es: Español"
                                required
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={3}>
                            <Form.Group controlId="editionYear">
                            <Form.Label>Año de edición </Form.Label>
                            <Form.Control
                                name={'editionYear'}
                                defaultValue={formData.editionYear}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>


                    <Row>
                        <Col sm={12} md={6}>
                            <Form.Group controlId="sellingRights">
                            <Form.Label>Derechos de venta</Form.Label>
                            <Form.Control
                                name={'sellingRights'}
                                defaultValue={formData.sellingRights}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} md={6}>
                            <Form.Group controlId="sellingConstraints">
                            <Form.Label>Restricciones de venta</Form.Label>
                            <Form.Control
                                name={'sellingConstraints'}
                                defaultValue={formData.sellingConstraints}
                                onChange={handleOnchange}
                                placeholder=""
                            ></Form.Control>
                            </Form.Group>
                        </Col> 
                    </Row> 
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                    <Button size="sm" variant="primary" type="submit">
                        Guardar cambios
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}